import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Supplier } from '../models/supplier.model';
import { CreateSupplierDto } from '../models/dtos/createSupplier.dto';
import { RestResponse } from '../models/restResponse.mode';
import { PaginatedList } from '../models/paginatedList.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {
  private readonly baseUrl = `${environment.base_url}/suppliers`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RestResponse<Supplier[]>> {
    return this.http.get<RestResponse<Supplier[]>>(`${this.baseUrl}`);
  }

  create(dto: CreateSupplierDto): Observable<RestResponse<Supplier>> {
    return this.http.post<RestResponse<Supplier>>(`${this.baseUrl}/create`, dto);
  }

  update(id: number, supplier: Supplier): Observable<RestResponse<Supplier>> {
    return this.http.put<RestResponse<Supplier>>(`${this.baseUrl}/update/${id}`, supplier);
  }

  getById(id: number): Observable<RestResponse<Supplier>> {
    return this.http.get<RestResponse<Supplier>>(`${this.baseUrl}/find/${id}`);
  }

  find(id: number): Observable<RestResponse<Supplier>> {
    return this.http.get<RestResponse<Supplier>>(`${this.baseUrl}/find/${id}`);
  }

  list(search: string = '', active: boolean | null = null, page: number = 1): Observable<RestResponse<PaginatedList<Supplier[]>>> {
    const params: any = { page };
    if (search) params.search = search;
    if (active !== undefined && active !== null) params.active = active;
    return this.http.get<RestResponse<PaginatedList<Supplier[]>>>(`${this.baseUrl}/list`, { params });
  }

  delete(id: number): Observable<RestResponse<object>> {
    return this.http.delete<RestResponse<object>>(`${this.baseUrl}/delete/${id}`);
  }
}
